import { ExportResult } from '@opentelemetry/core';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { ReadableSpan } from '@opentelemetry/sdk-trace-web';

export class CustomOTLPTraceExporter extends OTLPTraceExporter {
  private readonly getToken: () => string | null;

  private readonly baseHeaders: Record<string, unknown>;

  constructor(
    config: { url: string; headers: Record<string, string> },
    getToken: () => string | null
  ) {
    super(config);
    this.getToken = getToken;
    this.baseHeaders = { ...config.headers };
  }

  export(
    items: ReadableSpan[],
    resultCallback: (result: ExportResult) => void
  ) {
    // Create headers function that dynamically generates headers without storing tokens
    const headersFunction = () => {
      const token = this.getToken();
      return {
        ...this.baseHeaders,
        ...(token ? { Authorization: `Token ${token}` } : {}),
      };
    };

    // @ts-expect-error - Accessing internal OpenTelemetry transport parameters
    const params = this._delegate?._transport?._transport?._parameters;

    if (typeof params === 'object' && params !== null) {
      // Set headers as a function that gets called on each request
      params.headers = headersFunction;
    }

    return super.export(items, resultCallback);
  }
}

// OTLPTraceExporter does not renew the headers by default. SO when the user logsout and back in again, the requests are made with the previous token.
// This is a workaround to renew the headers.
// taken from https://github.com/open-telemetry/opentelemetry-js/issues/2903
